
import { DateTime } from 'luxon';
import { numberFormat, makeCenterLine, makeFixedLine, maskCardNumber, datetimeFormat } from "utils/common";
import { getParkingTid } from "features/parking/usecases/CarInOutUsecases";
import { toast } from "react-toastify";

export const onGetParkingTid = async (parkingId, localEntryId) => {
    const response = await getParkingTid({
        parkingId: parkingId,
        localEntryId: localEntryId,
    });
    if (response) {
        return response;
    }
    return null;
}

// utils/parkingUtils.js
export const printReceipt = async ({
    user,
    data, // data is the object containing the information to be printed
    type, // type is the type of receipt (entry or payment)
    setLoading =  () => {} // setLoading is a function to set app loading state
}) => {
    try {
        setLoading(true);
        let form;
        const commonFields = `
  ================================================
  ${makeCenterLine('근무자 휴식시간 안내')}
  * 현장근무자 휴식시간 및 전화가 꺼져있는 경우 하단 관리자번호로 차량번호 필수 작성 후 문자 보내주세요. 주차요금 계좌번호 등 문자 전송해 드립니다.
  ================================================
  ${makeCenterLine('미납요금 납부방법')}
  송파구시설관리공단 공영주차부 홈페이지 (www.songpagongdanpark2.or.kr) 미납요금 조회 및 요금을 납부하실 수 있습니다.
  ================================================
  ${makeCenterLine('결제문의')}
  주차관리자 관리자 번호 전화기가 꺼져있을경우 문자 남겨주세요.
  ================================================
  ${makeCenterLine('송파구시설관리공단')}
  `;

        if (type === 'entry') {
            form = `
  ${makeCenterLine('[주차표]')}
  ================================================
  ${makeFixedLine('구획번호:', data?.spaceNumber)}
  ${makeFixedLine('차량번호:', data?.carNum)}
  ${makeFixedLine('주차장소:', user?.parking?.parkingName)}
  ${makeFixedLine('관리자번호:', user?.parking?.phoneNumber)}
  ${makeFixedLine('입차시간:', DateTime.fromFormat(data?.inTime, 'yyyyMMddHHmmss').toFormat('yyyy-MM-dd HH:mm'))}
  ${makeFixedLine('사업자번호:', window.APP_CONFIG?.bizRegNo || '')}
  ${makeFixedLine('주차문의:', user?.parking?.phoneNumber)}
  ${commonFields}
  `;
        } else if (type === 'entry_out') {
            form = `
  ${makeCenterLine('[주차표]')}
  ================================================
  ${makeFixedLine('구획번호:', data?.spaceNumber || '')}
  ${makeFixedLine('차량번호:', data?.carNum || '')}
  ${makeFixedLine('주차장소:', user?.parking?.parkingName || '')}
  ${makeFixedLine('관리자번호:', user?.parking?.phoneNumber || '')}
  ${makeFixedLine('입차일시:', DateTime.fromFormat(data?.inTime, 'yyyyMMddHHmmss').toFormat('yyyy-MM-dd HH:mm') || '')}
  ${makeFixedLine('출차일시:', DateTime.fromFormat(data?.outTime, 'yyyyMMddHHmmss').toFormat('yyyy-MM-dd HH:mm') || '')}
  ${makeFixedLine('사업자번호:', window.APP_CONFIG?.bizRegNo || '')}
  ${makeFixedLine('주차문의:', user?.parking?.phoneNumber || '')}
  ${commonFields}
  `;
        } else if (type === 'unpaid') {
            form = `
  ${makeCenterLine('[주차표]' || '')}
  ================================================
  ${makeFixedLine('구획번호:', data?.spaceNumber || '')}
  ${makeFixedLine('차량번호:', data?.carNum || '')}
  ${makeFixedLine('주차장소:', user?.parking?.parkingName || '')}
  ${makeFixedLine('관리자번호:', user?.parking?.phoneNumber || '')}
  ${makeFixedLine('입차시간:', datetimeFormat(data?.inTime, "ISO", "yyyy-MM-dd HH:mm") || '')}
  ${makeFixedLine('출차시간:', datetimeFormat(data?.outTime, "ISO", "yyyy-MM-dd HH:mm") || '')}
  ${makeFixedLine('결제금액:', numberFormat(data?.paymentAmount || 0, "원"))}
  ${makeFixedLine('거래일시:', data?.serverTime || '')}
  ${makeFixedLine('사업자번호:', window.APP_CONFIG?.bizRegNo || '')}
  ${makeFixedLine('주차문의:', user?.parking?.phoneNumber || '')}
  ${commonFields}
  `;
        } else if (type === 'payment') {
            form = `
  ${makeCenterLine('매출전표' || '')}
  ================================================
  ${makeFixedLine('No:', ( window.APP_CONFIG?.parkingSeq || '000010') )}
  ${makeFixedLine('주차장명:', user?.parking?.parkingName || '')}
  ${makeFixedLine('사업자주소:', user?.parking?.address || '')}
  ${makeFixedLine('전화번호:', user?.parking?.phoneNumber || '')}
  ${makeFixedLine('일시:', data?.serverTime || '')}
  ================================================
  ${makeFixedLine('차량번호:', data?.carNumber || '')}
  ${makeFixedLine('입차일시:', datetimeFormat(data?.inTime, 'ISO', 'yyyy-MM-dd HH:mm') || '')}
  ${makeFixedLine('출차일시:', datetimeFormat(data?.outTime, 'ISO', 'yyyy-MM-dd HH:mm') || '')}
  ${makeFixedLine('주차시간:', numberFormat(data?.parkingMinute || 0, "분"))}
  ${makeFixedLine('주차요금:', numberFormat(data?.feeCalculated || 0, "원"))}
  ${makeFixedLine('할인금액:', numberFormat(data?.feeDiscount || 0, "원"))}
  ${makeFixedLine('정산금액:', numberFormat(data?.feeFinal || 0, "원"))}
  ================================================
  ${makeFixedLine('카드번호:', maskCardNumber(data?.track2Data) || '')}
  ${makeFixedLine('승인번호:', data?.authNo || '')}
  ${makeFixedLine('카드사명:', data?.issuerCompany || '')}
  ${makeFixedLine('매입사명:', data?.buyerCompany || '')}
  ================================================
  ${makeCenterLine('이용해 주셔서 감사합니다.' || '')}
  `;
        }
        // alert(form);
        const payKey = onGetParkingTid(user?.parking?.parkingId);

        const params = new URLSearchParams({
            billType: '9',
            terminalNo: payKey.tid,
            orderKey: '99999',
            printResType: '1',
            resScheme: 'innodep://printResponse',
        });

        if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
            window.ReactNativeWebView.postMessage(
                JSON.stringify({ type: 'print', body: params.toString(), printForm: form })
            );
        } else {
            throw new Error('Cannot find Native App');
        }
    } catch (error) {
        console.error('Printing failed:', error);
        alert(error.message);
    } finally {
        setLoading(false);
    }
};


export const handlePaymentResponse = (
    {
        event,
        onSuccess = () => { },
        onError = () => { },
        onNotInstalled = () => { },
        setLoading = () => { },
    }) => {
    try {
        const msg = JSON.parse(event.data);
        if (msg.type === 'payRes') {
            if (['0000', '0021'].includes(msg.body.responseCode)) {
                onSuccess(msg.body);
            } else {
                setLoading(false);
                onError();
            }
        } else if (msg.type === 'printRes') {
            if (['0000', '0021'].includes(msg.body.responseCode)) {
                setLoading(false);
                showSuccessToast();
            }
        } else if (msg.type === 'notInstalled') {
            setLoading(false);
            onNotInstalled();
        }
    } catch (e) {
        console.error('Fail to parse message:', e);
        setLoading(false);
        alert(e.message);
    }
};

export const showSuccessToast = () => {
    toast.success('성공했습니다.', {
        position: 'top-center',
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        className: 'htToastSuccess',
    });
};